import { api } from './customers'

export interface CustomerJourney {
    id: number
    customerId: number
    customerJourneyOption: string
    createdAt: string
}
export interface IvfJourney {
    id: number
    customerId: number
    stepsId: string
    stagesId: string
    stepsname: string
    stagesname: string



    createdAt: string
}

type CustomerJourneysResponse = CustomerJourney[]


export const CustomerJourneyMasterApi = api.injectEndpoints({
    endpoints: (build) => ({
        getCustomerJourneyMasters: build.query<CustomerJourneysResponse, any>({
            query: (pagi) => `customer_journey_master?page=${pagi?.pageNo}&filter=${pagi?.name}`,
        }),
        addCustomerJourneyMaster: build.mutation<CustomerJourney, Partial<CustomerJourney>>({
            query: (body) => ({
                url: `customer_journey_master`,
                method: 'POST',
                body,
            }),
            transformResponse: (response: { data: CustomerJourney }, meta, arg) => response.data,
        }),
        getCustomerJourneyMaster: build.query<CustomerJourney, string>({
            query: (id) => `customer_journey_master/${id}`,
            transformResponse: (response: { data: CustomerJourney }, meta, arg) => response.data,
        }),
        updateCustomerJourneyMaster: build.mutation<void, Pick<CustomerJourney, 'id'> & Partial<CustomerJourney>>({
            query: ({ id, ...patch }) => ({
                url: `customer_journey_master/${id}`,
                method: 'PUT',
                body: patch,
            }),
        }),
    }),
})

export const {
    useGetCustomerJourneyMastersQuery,
    useGetCustomerJourneyMasterQuery,
    useAddCustomerJourneyMasterMutation,
    useUpdateCustomerJourneyMasterMutation
} = CustomerJourneyMasterApi

